import apiClient from '@/api/index'

export default {
  index (riderId, params) {
    return apiClient.get(`/riders/${riderId}/media`, { params })
  },
  store (riderId, formData) {
    return apiClient.post(`/riders/${riderId}/media`, formData)
  },
  show (riderId, mediaId, params) {
    return apiClient.get(`/riders/${riderId}/media/${mediaId}`, { params })
  },
  update (riderId, mediaId, formData) {
    formData.append('_method', 'PUT')
    return apiClient.post(`/riders/${riderId}/media/${mediaId}`, formData)
  },
  destroy (riderId, mediaId) {
    return apiClient.delete(`/riders/${riderId}/media/${mediaId}`)
  }
}
